import { ReactElement } from 'react';
import { useTranslation } from '@jobcost-monorepo/i18n';

const SendFormTitle = (): ReactElement => {
  const { t } = useTranslation('timesheets');

  return (
    <div>
      <p className="text-pink text-2xl">{t(`email.title`)}</p>
    </div>
  );
};

export default SendFormTitle;
